
<div class="smartphone">
  <div class="content">
    <div class="preview-title">
      <img class="preview-title-avatar"
        src="../../../../../assets/images/avatar-grey.svg"
      />
      <img class="preview-title-expand-down"
        src="../../../../../assets/icons/expand-down.svg"
      />
      <span class="preview-title-name">
        Agenda+
      </span>
    </div>
    <div class="preview-subtitle">
      Atalhos
    </div>
    <div class="items">
      <div class="item" *ngFor="let link of links">
        <mat-card class="link-card">
          <div>
            <app-icon
              [iconName]="link.iconWeb"
              [checked]="true"
              [circleSize]="20"
              [svgSize]="14"
              [matFontSize]="14"
            >
            </app-icon>
          </div>
          <div class="link-name">
            {{ link.name }}
          </div>
        </mat-card>
      </div>  

    </div>
  </div>
  <div class="bottom-menu">
    <div class="menu-item">
      <span class="material-icons-outlined">
        home
      </span>      
      <span>Início</span>
    </div>
    <div class="menu-item">
      <span class="material-icons-outlined">
        event
      </span>      
      <span>Calendário</span>
    </div>
    <div class="selected-menu-item">
      <span class="material-icons-outlined">
        apps
      </span>      
      <span>Atalhos</span>
    </div>
    <div class="menu-item">
      <span class="material-icons-outlined">
        pin_drop
      </span>      
      <span>Cheguei</span>
    </div>
    <div class="menu-item">
      <span class="material-icons-outlined">
        chat
      </span>      
      <span>Atendimento</span>
    </div>
  </div>
</div>